<!-- 切换台面 -->
<style>
    .change-table{
        transform: translate(100%,0);
        transition: transform .3s cubic-bezier(.25, 1.15, .35, 1.08);
        z-index: 1051;
    }
    .change-table.active{
        transform: translate(0,0);
    }
    .nav-tabs .nav-link.text-secondary:hover{
        border-color:transparent !important;
    }
    .change-table .bet-title{
        writing-mode:initial;
    }
    .change-table .bet-content{
        width: 100%;
    }
    .change-table .bet-content>div{
        padding-left: .25rem;
        justify-content:space-between!important
    }
    .change-table .bet-content>div>span{
        margin-left: 0 !important;
    }
</style>
<template>
    <div @click.stop :class="{active:isShowTable}" class="d-flex col-11 col-6 col-sm-5 col-md-5 col-lg-8 col-xxl-7 h-100 position-absolute change-table py-2 end-0 bg-dark rounded-start bg-opacity-75">
        <div class="d-flex flex-column">
            <!-- 伸展书签 -->
            <div @click.stop="showTable" class="d-flex position-absolute top-50 text-vertical start-0 bg-danger text-light rounded-start border border-2 border-warning border-end-0 translate-start-x-middle-y lh-sm px-1 py-2" role="button">
                <span>{{$t("room.changeTable")}}</span>
            </div>
            <!-- 游戏 -->
            <ul class="nav nav-tabs fw-bold px-2 border-0 line-bottom position-relative">
                <li v-for="item in gameList" :key="item" class="nav-item">
                    <span class="nav-link py-1" :class="[item==tabGame?'active':(unRoomGameList.indexOf(item)==-1?'text-light':'text-secondary')]" @click="getRoomList(item)">{{$t("common."+GAME_CODE[item])}}</span>
                </li>
            </ul>
            <!-- 台列表 -->
            <div class="flex-grow-1 h-0 text-light mt-2">
                <room-list :class="getTableClass" :room-list="roomList" :count-list="countList" :pearl-obj="pearlObj" :img-class="['w-6rem pt-8rem w-sm-7rem pt-sm-9rem']" :bet-class="['small']" :list-parent-class="[tabGame==GAME_ID.guess?'column-count-sm-2 column-count-lg-3':'d-flex']" @click-room="isShowTable=false" @on-ready="isModuleReady=true"></room-list>
            </div>
        </div>
    </div>
</template>
<script>
import { GAME_CODE,MUTATION_TYPE,GAME_ID } from '@/assets/js/config';
import roomList from '@/components/public/roomList.vue';
import { useLayer } from "@/assets/js/useLayer";
export default {
    components:{
        roomList
    },
    props: {
        //台面列表
        roomList:{
            type:Array,
            default:[]
        },
        //路单统计列表
        countList:{
            type:Array,
            default:[]
        },
        //要重绘路单的对象
        pearlObj:{
            id:0,//台面id
            pearl:[]//路单数据
        },
    },
    data() {
        return {
            GAME_ID,
            GAME_CODE,
            isShowTable:false,//是否展开切换台面
            isModuleReady:false,//页面内组件是否加载完成
        };
    },
    computed: {
        roomInfo() {
            return this.$store.state.roomInfo;
        },
        activeGame(){
            return this.$store.state.activeGame;
        },
        tabGame(){
            return this.$store.state.tabGame;
        },
        gameList(){
            return this.$store.state.gameList;
        },
        unRoomGameList(){
            return this.$store.state.unRoomGameList;
        },
        getTableClass(){
            let classStr="";
            if(this.$root.hasPearl(this.tabGame)){
                classStr="col-12 col-lg-6";
            }else{
                classStr="col-3";
            }
            if(this.tabGame==GAME_ID.guess){
                classStr="";
            }
            return classStr;
        },
    },
    created() {
        this.$store.commit({
            type:MUTATION_TYPE.setTabGame,
            tabGame:this.roomInfo.game==GAME_ID.lh?GAME_ID.bac:this.roomInfo.game
        })
    },
    methods: {
        /**
         * 展开或合上切换台面列表
         */
        showTable(){
            this.isShowTable=this.isShowTable?false:true;
            if(this.isShowTable){//显示状态下点击空白处隐藏
                document.onclick=(e)=>{
                    e.stopPropagation();
                    this.isShowTable=false;
                }
            }
        },
        /**
         * 获取游戏对应台面列表
         */
        getRoomList(gameId){
            if(this.isModuleReady){//当页面内组件加载完成时才能再次点击
                if(this.unRoomGameList.indexOf(gameId)!=-1){
                    useLayer({str:"游戏开发维护中！"});
                    return;
                }
                this.isModuleReady=false;
                (!this.$root.changeGame(gameId,"tabGame"))&&(this.isModuleReady=true);//切换不成功需要把组件加载状态置回空闲，否则下次无法操作
            }
        },
    },
};
</script>